export const STATUS_ACCEPTED = 5;

export const ERROR_POLICE_NOT_FOUND = 404;

export const RESET_ERROR = 'vzr/RESET_ERROR';

export const FETCH_POLICIES = 'vzr/FETCH_POLICIES';
export const FETCH_POLICIES_FAIL = 'vzr/FETCH_POLICIES_FAIL';
export const FETCH_POLICIES_SUCCESS = 'vzr/FETCH_POLICIES_SUCCESS';

export const FETCH_POLICY = 'vzr/FETCH_POLICY';
export const FETCH_POLICY_FAIL = 'vzr/FETCH_POLICY_FAIL';
export const FETCH_POLICY_SUCCESS = 'vzr/FETCH_POLICY_SUCCESS';

export const UPDATE_POLICY = 'vzr/UPDATE_POLICY';
export const UPDATE_POLICY_FAIL = 'vzr/UPDATE_POLICY_FAIL';
export const UPDATE_POLICY_SUCCESS = 'vzr/UPDATE_POLICY_SUCCESS';

export const ACCEPT_POLICY = 'vzr/ACCEPT_POLICY';
export const ACCEPT_POLICY_FAIL = 'vzr/ACCEPT_POLICY_FAIL';
export const ACCEPT_POLICY_SUCCESS = 'vzr/ACCEPT_POLICY_SUCCESS';

export const ANNUL_POLICY = 'vzr/ANNUL_POLICY';
export const ANNUL_POLICY_FAIL = 'vzr/ANNUL_POLICY_FAIL';
export const ANNUL_POLICY_SUCCESS = 'vzr/ANNUL_POLICY_SUCCESS';
